import { motion } from "framer-motion";
import { useMemo } from "react";

interface GoldenParticlesProps {
  count?: number;
  isSpecial?: boolean;
}

export function GoldenParticles({ count = 15, isSpecial = false }: GoldenParticlesProps) {
  const particles = useMemo(() => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      delay: Math.random() * 0.5,
      duration: 2 + Math.random() * 1,
      size: 4 + Math.random() * 6,
      color: isSpecial 
        ? (Math.random() > 0.5 ? "#FFD700" : "#FFA500")
        : (Math.random() > 0.5 ? "#D4A853" : "#F5D77A"),
    }));
  }, [count, isSpecial]);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {particles.map((particle) => (
        <motion.div
          key={particle.id}
          className="absolute rounded-full"
          style={{
            left: `${particle.x}%`,
            bottom: 0,
            width: particle.size,
            height: particle.size,
            backgroundColor: particle.color,
            boxShadow: `0 0 ${particle.size}px ${particle.color}`,
          }}
          initial={{ 
            y: 0, 
            opacity: 0,
            scale: 0,
          }}
          animate={{
            y: -300 - Math.random() * 200,
            opacity: [0, 1, 1, 0],
            scale: [0, 1, 1, 0.5],
            x: (Math.random() - 0.5) * 100,
          }}
          transition={{
            duration: particle.duration,
            delay: particle.delay,
            ease: "easeOut",
          }}
        />
      ))}
    </div>
  );
}
